import classNames from 'classnames'
import ReactSelect, {
  components,
  ControlProps,
  GroupBase,
  Props,
} from 'react-select'

import { ChevronDownIcon } from 'components/icons'

export type SelectProps<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = Props<Option, IsMulti, Group> & {
  isInvalid?: boolean
  touched?: boolean
}

const Control = ({ children, ...props }: ControlProps<any, any, any>) => (
  <components.Control className='select-form-control' {...props}>
    {children}
  </components.Control>
)

const DropdownIndicator = () => <ChevronDownIcon className='input-icon' />

function Select<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  className,
  components: customComponents,
  isInvalid,
  onBlur,
  touched,
  ...rest
}: SelectProps<Option, IsMulti, Group>) {
  const showError = isInvalid && touched

  return (
    <div
      className={classNames('position-relative input-container', className, {
        invalid: showError,
      })}
    >
      <ReactSelect
        {...rest}
        onBlur={(e) => onBlur?.(e)}
        components={{
          Control,
          DropdownIndicator,
          ...customComponents,
        }}
        classNamePrefix='select'
        className='select'
      />
    </div>
  )
}

export default Select
